export default (props) => (
  /**
   * Ícone utilizado para representar a legenda de uma camada.
   * Cor parametrizada.
   * Encontrado no menu de ações de camadas importadas.
   */
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.19727 2.32935H14.3544V1.32935H5.19727V2.32935ZM5.19727 8.16281H12.0211V7.16281H5.19727V8.16281Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <rect
      x="0.354492"
      y="0.268311"
      width="3.11113"
      height="3.11113"
      rx="0.5"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <rect
      x="0.354492"
      y="5.97794"
      width="3.11113"
      height="3.11113"
      rx="0.5"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
